export default {
    TOKEN_VALIDATED: 'TOKEN_VALIDATED',
    TOKEN_FETCHED: 'TOKEN_FETCHED',
    USER_FETCHED: 'USER_FETCHED',
    AUTH_LOADING: 'AUTH_LOADING',
    LOGOUT: 'LOGOUT',
    RESTORE_PASSWORD_VALIDATED: 'RESTORE_PASSWORD_VALIDATED'
};